// Helpers for mutual-fund portfolio assets (asset_type "mutual_fund"
// with an mf_holdings array; last_nav/nav_date are server-maintained).

/** "2 funds · NAVs of 11-08-2026" one-line summary for the assets list. */
export function mfSummary(asset) {
  const holdings = asset?.mf_holdings || [];
  const count = `${holdings.length} fund${holdings.length === 1 ? "" : "s"}`;
  const date = holdings.find((h) => h.nav_date)?.nav_date;
  return date ? `${count} · NAVs of ${date}` : count;
}

/**
 * Aggregate % gain vs. average buy NAVs. Only holdings with both an
 * avg_nav and a last_nav count; returns null when none qualify.
 */
export function mfGainPercent(asset) {
  let invested = 0;
  let current = 0;
  for (const h of asset?.mf_holdings || []) {
    const avg = Number(h.avg_nav);
    const last = Number(h.last_nav);
    if (!(h.units > 0) || !(avg > 0) || !(last > 0)) continue;
    invested += h.units * avg;
    current += h.units * last;
  }
  if (!invested) return null;
  return ((current - invested) / invested) * 100;
}
